import { isHotelPoi, isStationServiceRubric } from '../../store/geoentity/geoentity.helpers'
import {
  GEOENTITY_FUEL_CELL_TYPE,
  GEOENTITY_GENERIC_CELL_TYPE,
  GEOENTITY_HOTEL_CELL_TYPE
} from '../../store/geoentity/geoentity.constants'
import { selectHotelIdList } from '../../store/poiassets/poiassets.selectors'
import { useSelector } from 'react-redux'

const useGetGeoentityTypeForListItem = poi => {
  const hotelIdList = useSelector(selectHotelIdList)
  const isHotel = isHotelPoi(hotelIdList, poi)

  if (isStationServiceRubric(poi?.rubric?.id)) return GEOENTITY_FUEL_CELL_TYPE
  if (isHotel) return GEOENTITY_HOTEL_CELL_TYPE
  return GEOENTITY_GENERIC_CELL_TYPE
}

export default useGetGeoentityTypeForListItem
